//restapi
// export const API_URL = 'https://uznqn9mozb.execute-api.us-east-1.amazonaws.com/dev/todos'
//http api
//export const API_URL = 'https://ljhiolyvhe.execute-api.us-east-1.amazonaws.com/dev/todos'

//SAM api
//export const API_URL =  'https://eck0sloy5m.execute-api.us-east-1.amazonaws.com/todos'

//Serverless framework api - AWS
//export const API_URL =  'https://xv0ws8t5p9.execute-api.us-east-1.amazonaws.com/todos'

//Azure Local function app API
//export const API_URL =  'http://localhost:7071/api/todos'

//Azure function app API
//export const API_URL = 'https://todo-function-app-fotis.azurewebsites.net/api/todos'

//Azure API Management API
export const API_URL = 'https://todo-api-management-fotis-sla.azure-api.net/todo-function-app-fotis/todos'

//AWS user pool
export const POOL_DATA = {
    UserPoolId: 'us-east-1_PH3jGCeVW',//'us-east-1_7dF78dyvw',
    ClientId: '6j5qmgufmh78fm7l4gkd0dkvov'//'7pn13e127fqnptfp0glb3bke8e'
};